// extracted by mini-css-extract-plugin
module.exports = {"incommingTruckWrapper":"incomming-truck-circle_incommingTruckWrapper__2hLao","incommingAnimation":"incomming-truck-circle_incommingAnimation__yESZy"};